// React Imports
import * as React from 'react';
import {useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { FormHelperText, Input, InputLabel} from "@mui/material";

// App Imports
import {addContract, editContract} from "./ContractClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {changeContract} from "./contractSlice";


// Main Function
export default function ContractDrawer() {


    // ****************** BEGIN STATES ****************************

    const [showContractDrawer, setShowContractDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const selectorContractDrawerMode = useSelector((state) => state.contractSlc.value.contractDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN DISPATCH ****************************

    const DispatchData = useDispatch() ;

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my contract data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorContractDrawerMode==="Add"){
            addContract(data)
                .then(() => {
                    console.log("Contract added");
                    DispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                DispatchData(changeContract({id: 0, mcode: null, name: null, description: null,
                    status: null, hierarchy: null,
                    mockHealthCheck: null, mockException: null, mockImpeded: null, mockNeeded: null,
                    mockCompleted: null, mockTotalCDP: null, mockTotalFilters: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    partitionKey: null,
                    contractDrawerMode: null
                    // ,residualsTabsVisible: true
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    // ,participationsTabsVisible: false
                    // ,royaltiesTabsVisible: false,
                    ,contractDrawerState: false
                    ,cGridRefresh: true}));

            })}
        if(selectorContractDrawerMode==="Edit"){
            console.log("This is the contract Id I am going to edit")
            console.log(selectorContractId)

            editContract(selectorContractId, data)
                .then(() => {
                    console.log("Contract edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                DispatchData(changeContract({
                    contractDrawerMode: null
                    // ,residualsTabsVisible: true
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    // ,participationsTabsVisible: false
                    // ,royaltiesTabsVisible: false,
                    ,contractDrawerState: false
                    ,cGridRefresh: true
                }));
            })}
    };

    // ****************** END CRUD ****************************


    // ***************** BEGIN CONTROLS ***************************

    function openContractDrawer() {
        setShowContractDrawer(true);
    };

    function closeContractDrawer() {
        DispatchData(changeContract({
            // contractDrawerMode: null
            // ,residualsTabsVisible: true
            contractGridVisible: true,
            cGridRefresh: true,
            // ,contractDrilldownVisible: false
            // ,contractSearchVisible: false
            // ,contractConfigVisible: false
            // ,contractView: null
            // ,participationsTabsVisible: false
            // ,royaltiesTabsVisible: false,
            contractDrawerState: false
        }));
    };

    // *************** END CONTROLS *******************************


    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    // ****************** END MISC ****************************


    // ****************** BEGIN FORM ****************************

    function contractForm(){
        return(

            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1 style={{cursor:'pointer'}} onClick={() => closeContractDrawer()}>Contract Form</h1>
                    <h4>{selectorContractDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel  htmlFor="mcode">Code</InputLabel>
                    <Input
                        {...register('mcode', { required: true })}
                        id="mcode" name="mcode"  label="mcode" aria-describedby="mcode_entry"
                        defaultValue=        {useSelector((state) => state.contractSlc.value.mcode)}
                    />
                    <FormHelperText id="mcode_helper">enter a brief code in all caps</FormHelperText>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel  htmlFor="name">Name</InputLabel>
                    <Input
                        sx={{ m: 1, minWidth: 400 }}
                        {...register('name', { required: true })}
                        id="name" name="name"  label="name" aria-describedby="name_entry"
                        defaultValue=        {useSelector((state) => state.contractSlc.value.name)}
                    />
                    {/*<FormHelperText id="name_helper">enter a name</FormHelperText>*/}
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel  htmlFor="description">Description</InputLabel>
                    <Input
                        sx={{ m: 1, minWidth: 650 }}
                        {...register('description', { required: false })}
                        id="description" name="description"  label="description" aria-describedby="description_entry"
                        defaultValue=        {useSelector((state) => state.contractSlc.value.description)}
                    />
                    {/*<FormHelperText id="description_helper">enter a description</FormHelperText>*/}
                    <HiddenFields />
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeContractDrawer()}>Cancel</Button>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.status)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('ordinalNumber', { required: false })}
                       id="ordinalNumber" name="ordinalNumber"  label="ordinalNumber" aria-describedby="ordinalNumber_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.ordinalNumber)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('recordLevel', { required: false })}
                       id="recordLevel" name="recordLevel"  label="recordLevel" aria-describedby="recordLevel_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.recordLevel)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('hierarchy', { required: false })}
                       id="hierarchy" name="hierarchy"  label="hierarchy" aria-describedby="hierarchy_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.hierarchy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdOn', { required: false })}
                       id="createdOn" name="createdOn"  label="createdOn" aria-describedby="createdOn_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.createdOn)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.createdBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedOn', { required: false })}
                       id="lastModifiedOn" name="lastModifiedOn"  label="lastModifiedOn" aria-describedby="lastModifiedOn_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.lastModifiedOn)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       defaultValue=        {useSelector((state) => state.contractSlc.value.lastModifiedBy)}
                />
                {/*<Input style={{ visibility: "hidden" }}*/}
                {/*       {...register('partitionKey', { required: false })}*/}
                {/*       id="partitionKey" name="partitionKey"  label="partitionKey" aria-describedby="partitionKey_entry"*/}
                {/*       value= "Master"*/}
                {/*/>*/}
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={useSelector((state) => state.contractSlc.value.contractDrawerState)}
                initialState={{open: false}}
                onClose={closeContractDrawer}
            >
                {contractForm()}
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
